export class PageRequest {
  page?: number;
  size?: number;

  constructor(size?: number) {
    this.page = 0;
    size ? this.size = size : this.size = 10;
  }

  static default() {
    let pageRequest = new PageRequest();
    pageRequest.page = undefined;
    pageRequest.size = undefined;
    return pageRequest;
  }

  static of(page: number, size: number) {
    const pageRequest = new PageRequest();
    pageRequest.page = page;
    pageRequest.size = size;
    return pageRequest;
  }
}
